export default __webpack_public_path__ + "static/media/phone.b2c1ae6b.gif";